import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { useAuthStore } from "@/store/AuthStore";
import AdminMainViewWithAppBar from "@/views/admin/AdminMainViewWithAppBar.vue";
import CustomerMainViewWithAppBar from "@/views/customer/CustomerMainViewWithAppBar.vue";

/**
 * The app shell for a route that is not tied to either portal — today, the catch-all.
 *
 * It picks the shell from the signed-in user's role rather than from the URL, which matters
 * because the catch-all also renders a customer who wandered onto an /admin/... URL: showing
 * them the admin navigation would be both useless and a needless map of a portal they cannot
 * open. They get their own nav, at the URL they asked for.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PortalFrame',
  setup(__props) {

const authStore = useAuthStore();
const isAdmin = computed(() => authStore.isAdmin);

return (_ctx: any,_cache: any) => {
  return (isAdmin.value)
    ? (_openBlock(), _createBlock(AdminMainViewWithAppBar, { key: 0 }))
    : (_openBlock(), _createBlock(CustomerMainViewWithAppBar, { key: 1 }))
}
}

})